<template>
  <v-card flat class="transparent" v-if="items && items.length > 0">
    <v-card-text class="px-0 py-1 align-items-center d-inline-flex" style="overflow-x: scroll;">
      <v-icon small left color="accent">mdi-tag-outline</v-icon>
      <v-btn small depressed text dark color="secondary" v-for="(item, i) in items" :key="'t'+i" v-html="item.name" :href="'/tag/' + item.slug"></v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'PostTags',

    props: ['items']
  }
</script>